<div
    class="cmps-cdk-d-flex cmps-cdk-flex-column cmps-cdk-w-100pct cmps-cdk-h-100pct cmps-report-bg-color-ukn-103"
>
    <div
        class="cmps-cdk-bg-color-white cmps-cdk-d-flex cmps-cdk-justify-content-center cmps-cdk-h-55px cmps-cdk-min-h-55p cmps-cdk-z-index-2"
    >
        <div
            class="cmps-cdk-d-flex cmps-cdk-flex-80 cmps-cdk-p-0dot5 cmps-cdk-cg-0dot5"
        >
            <div
                class="cmps-cdk-align-items-center cmps-cdk-cg-0dot5 cmps-cdk-d-flex cmps-cdk-flex-grow-1"
            >
                <div
                    class="cmps-cdk-bg-color-blue-100 cmps-cdk-border-radius-4px cmps-cdk-p-0dot25"
                >
                    <cmps-icon
                        class="cmps-cdk-color-white nested:cmps-cdk-w-inherit nested:cmps-cdk-h-inherit cmps-cdk-w-28px cmps-cdk-h-28px"
                        svgIcon="compass-outline"
                    ></cmps-icon>
                </div>
                <div class="cmps-cdk-font-bold cmps-cdk-font-size-18p">
                    Report Builder
                </div>
            </div>
            <div
                class="cmps-cdk-align-items-center cmps-cdk-d-flex cmps-cdk-cg-0dot75"
            >
                <div>
                    <button
                        type="button"
                        class="cmps-cdk-align-items-center cmps-cdk-bg-color-white cmps-cdk-border-color-grey-300 cmps-cdk-border-radius-4px cmps-cdk-border-solid cmps-cdk-border-width-1p cmps-cdk-color-blue-100 not:disabled:cmps-cdk-cursor-pointer cmps-cdk-d-inline-flex cmps-cdk-font-bold cmps-cdk-justify-content-center cmps-cdk-min-h-34p cmps-cdk-px-1"
                        (click)="_onResetClick()"
                    >
                        <cmps-icon svgIcon="refresh"></cmps-icon>
                        <span class="cmps-cdk-line-clamp-1">Reset</span>
                    </button>
                </div>
                <div>
                    <button
                        type="button"
                        class="cmps-cdk-align-items-center cmps-cdk-bg-color-white cmps-cdk-border-color-grey-300 cmps-cdk-border-radius-4px cmps-cdk-border-solid cmps-cdk-border-width-1p cmps-cdk-color-blue-100 not:disabled:cmps-cdk-cursor-pointer cmps-cdk-d-inline-flex cmps-cdk-font-bold cmps-cdk-justify-content-center cmps-cdk-min-h-34p cmps-cdk-px-1 cmps-cdk-cg-0dot25"
                        (click)="_onPresetsClick()"
                    >
                        <cmps-icon svgIcon="briefcase-outline"></cmps-icon>
                        <span class="cmps-cdk-line-clamp-1">Presets</span>
                        <cmps-badge
                            [cmpsBadge]="'' + (_state.presets?.length ?? 0)"
                        ></cmps-badge>
                    </button>
                </div>
            </div>
        </div>
    </div>

    <div
        class="cmps-cdk-border-b-width-1p cmps-cdk-border-b-solid cmps-cdk-border-b-color-grey-100"
    ></div>

    <div
        class="cmps-cdk-bg-color-white cmps-cdk-d-flex cmps-cdk-justify-content-center cmps-uik-box-shadow-200 cmps-cdk-z-index-1"
    >
        <div class="cmps-cdk-d-flex cmps-cdk-flex-80 cmps-cdk-px-0dot5">
            <cmps-report-builder-selection-bar
                [step]="_state.step"
                [viewParamLabels]="_state.viewParamLabels"
                (change)="_changeStep($event)"
            ></cmps-report-builder-selection-bar>
        </div>
    </div>

    <div
        class="cmps-cdk-d-flex cmps-cdk-justify-content-center cmps-cdk-flex-grow-1 cmps-cdk-overflow-y-auto"
    >
        <div
            class="cmps-cdk-flex-80 cmps-cdk-px-0dot5 cmps-cdk-py-1 cmps-cdk-h-fit"
        >
            <div
                class="cmps-cdk-mx-auto cmps-cdk-d-flex cmps-cdk-flex-column cmps-cdk-rg-1"
                [class.cmps-cdk-max-w-768px]="_state.step !== _Step.Metrics"
                [class.cmps-cdk-max-w-1024px]="_state.step === _Step.Metrics"
            >
                <div class="cmps-cdk-d-flex cmps-cdk-flex-column cmps-cdk-rg-1">
                    <cmps-report-builder-data-source
                        *ngIf="_state.step === _Step.DataSource"
                    ></cmps-report-builder-data-source>

                    <cmps-report-builder-cache-date
                        *ngIf="
                            _state.step === _Step.Date &&
                            _state.viewParams?.dataSource === _DataSource.Cache
                        "
                    ></cmps-report-builder-cache-date>

                    <cmps-report-builder-raw-date
                        *ngIf="
                            _state.step === _Step.Date &&
                            _state.viewParams?.dataSource === _DataSource.Raw
                        "
                    ></cmps-report-builder-raw-date>

                    <cmps-report-builder-report-type
                        *ngIf="_state.step === _Step.ReportType"
                    ></cmps-report-builder-report-type>

                    <cmps-report-builder-dimension
                        *ngIf="_state.step === _Step.Dimensions"
                    ></cmps-report-builder-dimension>

                    <cmps-report-builder-cache-metric
                        *ngIf="_state.step === _Step.Metrics"
                    ></cmps-report-builder-cache-metric>
                </div>

                <div
                    class="cmps-cdk-cg-0dot75 cmps-cdk-d-flex cmps-cdk-justify-content-flex-end"
                >
                    <div *ngIf="!_state.atFinalStep">
                        <button
                            type="button"
                            class="cmps-cdk-align-items-center cmps-cdk-bg-color-blue-100 cmps-cdk-border-radius-4px cmps-cdk-border-width-0p cmps-cdk-color-white not:disabled:cmps-cdk-cursor-pointer cmps-cdk-d-inline-flex cmps-cdk-font-bold cmps-cdk-justify-content-center cmps-cdk-min-h-34p cmps-cdk-px-1"
                            (click)="_onNextClick()"
                        >
                            <span class="cmps-cdk-line-clamp-1">Next</span>
                        </button>
                    </div>

                    <ng-container *ngIf="_state.atFinalStep">
                        <div>
                            <button
                                type="button"
                                class="cmps-cdk-align-items-center cmps-cdk-bg-color-white cmps-cdk-border-color-grey-300 cmps-cdk-border-radius-4px cmps-cdk-border-solid cmps-cdk-border-width-1p cmps-cdk-color-blue-100 not:disabled:cmps-cdk-cursor-pointer cmps-cdk-d-inline-flex cmps-cdk-font-bold cmps-cdk-justify-content-center cmps-cdk-min-h-34p cmps-cdk-px-1"
                                [disabled]="_state.creatingPreset"
                                (click)="_onSavePresetClick()"
                            >
                                <span class="cmps-cdk-line-clamp-1"
                                    >Save as Preset</span
                                >
                            </button>
                        </div>

                        <div>
                            <button
                                type="button"
                                class="cmps-cdk-align-items-center cmps-cdk-bg-color-white cmps-cdk-border-color-grey-300 cmps-cdk-border-radius-4px cmps-cdk-border-solid cmps-cdk-border-width-1p cmps-cdk-color-blue-100 not:disabled:cmps-cdk-cursor-pointer cmps-cdk-d-inline-flex cmps-cdk-font-bold cmps-cdk-justify-content-center cmps-cdk-min-h-34p cmps-cdk-px-1"
                                (click)="_onScheduleClick()"
                            >
                                <span class="cmps-cdk-line-clamp-1"
                                    >Schedule</span
                                >
                            </button>
                        </div>

                        <div>
                            <button
                                type="button"
                                class="cmps-cdk-align-items-center cmps-cdk-bg-color-blue-100 cmps-cdk-border-radius-4px cmps-cdk-border-width-0p cmps-cdk-color-white not:disabled:cmps-cdk-cursor-pointer cmps-cdk-d-inline-flex cmps-cdk-font-bold cmps-cdk-justify-content-center cmps-cdk-min-h-34p cmps-cdk-px-1"
                                [disabled]="_state.creatingRun"
                                (click)="_onGenerateClick()"
                            >
                                <span class="cmps-cdk-line-clamp-1"
                                    >Generate Report</span
                                >
                            </button>
                        </div>
                    </ng-container>
                </div>
            </div>
        </div>
    </div>
</div>
